import { cn, HeaderStyles, X } from 'scbk-ui-web';

import { DataAttributes } from '../types/HeaderType';

import { useMemo } from 'react';
import { useAppContext } from 'scbk-services';

interface BgHeaderProps {
  title?: string | React.ReactNode | undefined;
  onClose?: () => void;
  isScrolled: boolean;
  showTitle?: boolean;
  titleProps?: DataAttributes;
  closeProps?: DataAttributes;
  openUserInfoPopup?: () => void;
  isCloseBtn?: boolean; //260723
}

const BgHeader = ({
  title,
  isScrolled = false,
  onClose,
  showTitle,
  titleProps,
  closeProps,
  openUserInfoPopup,
  isCloseBtn, //260723
}: BgHeaderProps) => {
  const { seniorMode } = useAppContext();

  const isLargeText = useMemo(() => {
    return seniorMode === 'Y';
  }, [seniorMode]);

  return (
    <div className={cn(HeaderStyles['sub-header-fixed'], isScrolled ? HeaderStyles.scrolled : '')}>
      <header className={HeaderStyles['sub-bg-header']}>
        <h1
          className={`${HeaderStyles.title} ${showTitle ? 'md:block' : 'md:hidden'}`}
          {...titleProps}
          onClick={(e) => {
            e.preventDefault();
            openUserInfoPopup?.();
          }}
        >
          {title}
        </h1>
        {isCloseBtn && (
          <button id="btnHeaderClose" aria-label="닫기" onClick={onClose} {...closeProps}>
            <X fill={!isScrolled || isLargeText ? '#fff' : '#000'} width={24} height={24} />
          </button>
        )}
      </header>
    </div>
  );
};

export { BgHeader };
